import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import LocationSelectField from './LocationSelectField';
import RaisedButton from 'material-ui/RaisedButton';
import {
    Table,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
    TableBody
} from 'material-ui';
import ContentDelete from 'material-ui/svg-icons/action/delete';
import {sortArrayByKey} from '../shared/functions';
import {getPayloadLocationFromProps} from '../shared/scheduledReportFunctions';
import FuseTheme from '../global/theme';

const styles = {
    buttonContainer: {display: 'inline-block', marginBottom: 12, verticalAlign: 'bottom'},
    button: {color: FuseTheme.palette.primary3Color, verticalAlign: 'bottom'},
    iconButton: {color: FuseTheme.palette.primary3Color},
    submitButton: {display: 'block', float: 'right', margin: '1em 0 1em 0'}
};

/**
 * Location selection and Locations table for Secondary Filters
 *
 */
class LocationsTableFilter extends Component {
    constructor(props) {
        super(props);

        const recordObj = getPayloadLocationFromProps(props);
        const recordLocationIds = (recordObj && recordObj.locations) ? recordObj.locations : [];
        this.state = {
            addedLocations: [],
            recordLocationIds: recordLocationIds,
            selectedLocation: null,
        };
        this.getAddedLocations = this.getAddedLocations.bind(this);
        this.handleSelectLocationOption = this.handleSelectLocationOption.bind(this);
    }

    getAddedLocations() {
        return JSON.parse(JSON.stringify(this.state.addedLocations));
    }

    handleLocationsLoaded = (locations) => {
        const ids = JSON.parse(JSON.stringify(this.state.recordLocationIds));
        let addedLocations = this.getAddedLocations();
        const locTotal = ids.length;
        const addedTotal = addedLocations.length;
        if (locTotal > 0) {
            for (let i = 0; i < locTotal; i++) {
                let id = parseInt(ids[i], 10);
                let locIdx = locations.findIndex(n => n.id === id);
                let addedIdx = (addedTotal > 0) ? addedLocations.findIndex(n => n.id === id) : -1;
                if (locIdx !== -1 && addedIdx === -1) {
                    addedLocations.push(locations[locIdx]);
                }
            }
            let sorted = sortArrayByKey(addedLocations, 'id', 'ASC');
            this.setState({
                addedLocations: sorted,
                selectedLocation: null
            }, () => {
                if (typeof this.props.onLocationUpdate === 'function') {
                    this.props.onLocationUpdate(this.state.addedLocations);
                }
            });
        }
    }

    handleSelectLocationOption(event, index, value) {
        if (index && index.id) {
            this.setState({
                selectedLocation: index
            });
        }
    }

    handleAddLocation() {
        let selected = this.state.selectedLocation;
        let addedLocations = this.getAddedLocations();
        let idx = addedLocations.findIndex(n => n.id === selected.id);
        if (idx === -1) {
            addedLocations.push(selected);
            let sorted = sortArrayByKey(addedLocations, 'id', 'ASC');
            this.setState({
                addedLocations: sorted,
                selectedLocation: null
            }, () => {
                if (typeof this.props.onLocationUpdate === 'function') {
                    this.props.onLocationUpdate(this.state.addedLocations);
                }
            });
        }
    }

    handleRemoveLocation(id) {
        let addedLocations = this.getAddedLocations();
        let idx = addedLocations.findIndex(n => n.id === id);
        if (idx !== -1) {
            addedLocations.splice(idx, 1);
            this.setState({
                addedLocations: addedLocations
            }, () => {
                if (typeof this.props.onLocationUpdate === 'function') {
                    this.props.onLocationUpdate(this.state.addedLocations);
                }
            });
        }
    }

    handleSubmitLocations() {
        if (typeof this.props.onLocations === 'function') {
            this.props.onLocations(null, this.state.addedLocations);
        }
    }

    renderLocationTable = (list) => {
        if (!list || list.length === 0) {
            return (
                [0].map(() => (
                    <TableRow key={`no-locations-added`}>
                        <TableRowColumn columnNumber={2}>No Locations Added</TableRowColumn>
                    </TableRow>
                ))
            )
        }
        return (
            list.map((item, index) => (
                <TableRow key={item.id.toString() + index}>
                    <TableRowColumn>{item.filter_name}</TableRowColumn>
                    <TableRowColumn>
                        <IconButton
                            style={styles.iconButton}
                            onClick={() => this.handleRemoveLocation(item.id)}
                        >
                            <ContentDelete/>
                        </IconButton>
                    </TableRowColumn>
                </TableRow>
            ))
        )
    };

    render() {
        const {
            includeSubmit
        } = this.props;

        const {
            addedLocations,
            selectedLocation
        } = this.state;

        return (
            <Fragment>
                <LocationSelectField
                    selectionType="object"
                    onLocationsLoaded={this.handleLocationsLoaded}
                    onSelectLocation={this.handleSelectLocationOption}
                />
                <RaisedButton
                    primary
                    type="button"
                    label="Add"
                    style={styles.buttonContainer}
                    buttonStyle={styles.button}
                    disabled={(!selectedLocation)}
                    onClick={() => this.handleAddLocation()}
                />
                <Table selectable={false} multiSelectable={false}>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow>
                            <TableHeaderColumn>Location</TableHeaderColumn>
                            <TableHeaderColumn>Remove</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false}>
                        {[...this.renderLocationTable(addedLocations)]}
                    </TableBody>
                </Table>
                {includeSubmit &&
                    <RaisedButton
                        primary
                        type="button"
                        label="Generate Report"
                        style={styles.submitButton}
                        disabled={(addedLocations.length <= 0)}
                        onClick={() => this.handleSubmitLocations()}
                    />
                }
            </Fragment>
        );
    }
}

LocationsTableFilter.propTypes = {
    includeSubmit: PropTypes.bool,
    onLocations: PropTypes.func,
    onLocationUpdate: PropTypes.func,
    record: PropTypes.object
};

LocationsTableFilter.defaultProps = {
    includeSubmit: true,
    record: {}
};

export default LocationsTableFilter;



// WEBPACK FOOTER //
// ./src/Fuse/components/LocationsTableFilter.js